<template>
  <v-card>
    <v-row no-gutters class="pt-2"  justify="end">
      <v-btn color="color-grey" depressed right text small @click="$emit('close')">
        <v-icon class="mr-3">fa-times</v-icon>
        <span>{{ $t('close') }}</span>
      </v-btn>
    </v-row>
    <v-container class="pt-0" fluid>
      <v-row justify="center">
        <h4 class="mt-0 text-h4">{{ $t('pcd-text-1') }}</h4>
      </v-row>
      <v-row justify="center">
        <p class="mb-0 text-body-2">{{ $t('pcd-text-2') }}</p>
        <p class="text-body-2">{{ $t('pcd-text-3') }}</p>
      </v-row>
      <v-row justify="center">
        <form @submit.prevent="authenticateUser" autocomplete="off">
          <v-row justify="center">
            <v-col class="mt-6" cols="12" sm="9">
              <v-text-field outline
                            name="pin"
                            :label="$t('pcd-text-4')"
                            id="pin"
                            v-model="pin"
                            @blur="$v.pin.$touch()"
                            :error-messages="pinError"
                            maxlength="4"
                            required></v-text-field>
            </v-col>
            <v-col cols="12" sm="9">
              <v-btn block tile color="primary" class="mb-4" type="submit" :disabled="loading || this.$v.pin.$error" :loading="loading">
                {{ $t('login') }}
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-row>
      <v-row justify="center">
        <p class="mb-0 text-body-2">{{ $t('pcd-text-5') }}</p>
        <p class="text-body-2">{{ $t('pcd-text-6') }}</p>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    props: ['userData'],
    data: function () {
      return {
        pin: ''
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      pinError () {
        const errors = []
        if (!this.$v.pin.$dirty) return errors
        !this.$v.pin.required && errors.push(this.$t('pinErrors.required'))
        !this.$v.pin.numeric && errors.push(this.$t('pinErrors.numeric'))
        !this.$v.pin.minLength && errors.push(this.$t('pinErrors.length'))
        !this.$v.pin.maxLength && errors.push(this.$t('pinErrors.length'))
        return errors
      }
    },
    methods: {
      authenticateUser () {
        var credentials = {
          LoginType: 1,
          Identifier: this.userData.Identifier,
          PhoneNumber: this.userData.PhoneNumber,
          PinCode: this.pin
        }
        this.$store.dispatch('authenticateUser', credentials)
      }
    },
    validations: {
      pin: {
        required,
        numeric,
        minLength: minLength(4),
        maxLength: maxLength(4)
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "pcd-text-1": "Syötä vahvistuskoodi:",
  "pcd-text-2": "Saat pian puhelimeesi 4-numeroisen PIN-koodin.",
  "pcd-text-3": "Syötä se alla olevaan kenttään kirjautuaksesi Oma B2 Impact -palveluun:",
  "pcd-text-4": "Syötä PIN",
  "pcd-text-5": "Etkö saanut koodia? Tarkista, että syötit puhelinnumerosi oikein edellisessä kohdassa.",
  "pcd-text-6": "Mikäli ongelma jatkuu, ota yhteyttä asiakaspalveluumme.",
  "pinErrors": {
  "required": "PIN-koodi on pakollinen",
  "numeric": "PIN-koodin tulee olla numero",
  "length": "PIN-koodi tulee olla 4 numeroa pitkä"
  }
  },
  "se": {
  "pcd-text-1": "Fyll i verifikationskoden:",
  "pcd-text-2": "Du får snart en 4-siffrig PIN-kod till din telefon.",
  "pcd-text-3": "Fyll i den i fältet nedan för att kunna logga in i tjänsten:",
  "pcd-text-4": "Fyll i PIN-koden",
  "pcd-text-5": "Fick du ingen kod? Kontrollera att du fyllde i ditt telefonnummer korrekt.",
  "pcd-text-6": "Ifall problemet kvarstår, kontakta vår kundtjänst.",
  "pinErrors": {
  "required": "PIN-kod är obligatoriskt",
  "numeric": "PIN-kod bör vara numeriskt",
  "length": "PIN-kod bör vara mellan 4 tecken"
  }
  },
  "en": {
  "pcd-text-1": "Fill in your verification code:",
  "pcd-text-2": "You will soon receive a 4-digit PIN-code to your phone.",
  "pcd-text-3": "Enter it to the field below, in order to log in to the service:",
  "pcd-text-4": "Enter the PIN-code",
  "pcd-text-5": "Did you not receive a PIN-code? Please make sure that you filled in your phonenumber correctly.",
  "pcd-text-6": "If the problem persists, contact our customer service.",
  "pinErrors": {
  "required": "PIN-code is mandatory",
  "numeric": "PIN-code must be numeric",
  "length": "PIN-code must be between 4 numbers long"
  }
  }
  }
</i18n>
